

































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {ItrackCollection} from '@/helpers'
import Motorista from '@/model/resource/Motorista'
import DeliveryTrackingRequest from '@/model/request/DeliveryTrackingRequest'
import {$} from 'simpli-web-sdk'

@Component
export default class FilterDeliveryTracking extends Mixins(MixinMember) {
  @Prop({type: Object, required: true}) value!: DeliveryTrackingRequest

    allMotorista = ItrackCollection.allMotoristaFiltro

    get motoristaResource() {
        return this.allMotorista.get(this.value.idMotorista)
    }
    set motoristaResource(val: Motorista | null) {
        this.value.idMotorista = val && val.$id || null
    }

  mounted() {
    this.allMotorista.query()
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }
}
